import { MapTo } from "@adobe/aem-react-editable-components";
import { ContentRestriction } from "@jti/loyalty";
import { withAemAuthoring } from "../../app-related/withAemAuthoring";
export const contentRestrictionEditConfig = {
    emptyLabel: "ContentRestriction",
    isEmpty: (props) => !props.bgImage || !props.bgImageMobile || !props.title || !props.description || !props.theme,
    getProps: (props) => ({
        title: props.title,
        description: props.description,
        theme: props.theme,
        infoLink: props.infoLink,
        infoText: props.infoText,
        bgImage: props.bgImage,
        bgImageMobile: props.bgImageMobile,
        contentrestrictionlist: props.contentrestrictionlist,
        isInEditor: props.isInEditor,
    }),
};
export default MapTo("loyalty/components/contentrestriction")(withAemAuthoring(ContentRestriction, contentRestrictionEditConfig));
